var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.element,_vm._b({tag:"component",class:[
        'badge',
        ("bg-" + _vm.type),
        {'rounded-pill':_vm.pill},
        {'badge-inverse':_vm.inverse}
    ]},"component",_vm._d({},[_vm.href,_vm.link])),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }